import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Proposals',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.proposal',
            },
          },
        ],
      },
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'proposals',
                },
              },
              subqueries: {
                proposals: {
                  target: 'ent:!proposals:!proposal',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          id: {
                            '{}': {
                              value: {
                                '@.': '!id',
                              },
                            },
                          },
                          name: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                          client: {
                            '{}': {
                              value: {
                                '@.': '!client',
                              },
                            },
                          },
                          status: {
                            '{}': {
                              value: {
                                '@.': '!status',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              target: 'ent:!proposals:!proposal',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      amount: {
                        '{}': {
                          value: {
                            '@.': '!amount',
                          },
                        },
                      },
                      client: {
                        '{}': {
                          value: {
                            '@': 'client',
                          },
                        },
                      },
                      domain: {
                        '{}': {
                          value: {
                            '@': 'domain',
                          },
                        },
                      },
                      status: {
                        '{}': {
                          value: {
                            '@.': '!status',
                          },
                        },
                      },
                      dueDate: {
                        '{}': {
                          value: {
                            '@.': '!due_date',
                          },
                        },
                      },
                      orgOffering: {
                        '{}': {
                          value: {
                            '@': 'orgOffering',
                          },
                        },
                      },
                      proposalLead: {
                        '{}': {
                          value: {
                            '@': 'proposalLead',
                          },
                        },
                      },
                      proposalTeam: {
                        '{}': {
                          value: {
                            '@': 'proposalTeam',
                          },
                        },
                      },
                    },
                  },
                  onEdit: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              goto: {
                                '{}': {
                                  variables: {
                                    '{}': {
                                      proposalId: {
                                        '@.': '!id',
                                      },
                                    },
                                  },
                                  navigationId: 'proposal.details',
                                },
                              },
                            },
                          },
                          operation: 'ui.navigate',
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                client: {
                  ref: {
                    attr: 'attr:ent#!proposals#!proposal:!client',
                  },
                  target: 'ent:!clients:!client',
                  selection: {
                    '@.': '!name',
                  },
                },
                domain: {
                  ref: {
                    attr: 'attr:ent#!proposal_domain#!entry:!domain',
                  },
                  using: 'proposalDomain',
                  target: 'ent:!domains:!domain',
                  selection: {
                    '@.': '!name',
                  },
                },
                orgOffering: {
                  ref: {
                    attr: 'attr:ent#!proposals#!proposal:!org_offering',
                  },
                  target: 'ent:!org_offering:!entry',
                  selection: {
                    '@.': '!name',
                  },
                },
                proposalLead: {
                  ref: {
                    attr: 'attr:ent#!proposal_personnel#!entry:!proposal',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': '!type',
                      },
                      'Proposal Lead',
                    ],
                  },
                  target: 'ent:!proposal_personnel:!entry',
                  selection: {
                    '@': 'personnel',
                  },
                  subqueries: {
                    personnel: {
                      ref: {
                        attr: 'attr:ent#!proposal_personnel#!entry:!personnel',
                      },
                      target: 'ent:!personnel:!employee',
                      selection: {
                        '@.': '!name',
                      },
                    },
                  },
                },
                proposalTeam: {
                  ref: {
                    attr: 'attr:ent#!proposal_personnel#!entry:!proposal',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': '!type',
                      },
                      'Proposal Team',
                    ],
                  },
                  target: 'ent:!proposal_personnel:!entry',
                  selection: {
                    '@': 'personnel',
                  },
                  subqueries: {
                    personnel: {
                      ref: {
                        attr: 'attr:ent#!proposal_personnel#!entry:!personnel',
                      },
                      target: 'ent:!personnel:!employee',
                      selection: {
                        '@.': '!name',
                      },
                    },
                  },
                },
                proposalDomain: {
                  ref: {
                    attr: 'attr:ent#!proposal_domain#!entry:!proposal',
                  },
                  target: 'ent:!proposal_domain:!entry',
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'id',
                  direct: {
                    '{}': {
                      name: 'ID',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'status',
                  direct: {
                    '{}': {
                      name: 'Status',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'client',
                  direct: {
                    '{}': {
                      name: 'Client',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'orgOffering',
                  direct: {
                    '{}': {
                      name: 'Organization Offering',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'dueDate',
                  direct: {
                    '{}': {
                      name: 'Due Date',
                      type: 'DATE',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'amount',
                  direct: {
                    '{}': {
                      name: 'Amount',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'domain',
                  direct: {
                    '{}': {
                      name: 'Domain',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'proposalLead',
                  direct: {
                    '{}': {
                      name: 'Proposal Lead',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'proposalTeam',
                  direct: {
                    '{}': {
                      name: 'Proposal Team',
                      type: 'TEXT',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'create.proposal.modal',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
}
